// Generated by purs version 0.15.15
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Show_Generic from "../Data.Show.Generic/index.js";
import * as Data_UUID from "../Data.UUID/index.js";
import * as Foreign_Encoding from "../Foreign.Encoding/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Restaumatic_Analytics_Types_ItemList from "../Restaumatic.Analytics.Types.ItemList/index.js";
import * as Restaumatic_Form_TestHelpers from "../Restaumatic.Form.TestHelpers/index.js";
import * as Unscramble from "../Unscramble/index.js";
import * as Unscramble_Generic from "../Unscramble.Generic/index.js";
var eq = /* #__PURE__ */ Data_Eq.eq(/* #__PURE__ */ Data_Maybe.eqMaybe(Restaumatic_Analytics_Types_ItemList.eqItemList));
var eq1 = /* #__PURE__ */ Data_Eq.eq(Data_UUID.eqUUID);
var listIsSymbol = {
    reflectSymbol: function () {
        return "list";
    }
};
var trackingIdIsSymbol = {
    reflectSymbol: function () {
        return "trackingId";
    }
};
var CheckoutTrackingItemIsSymbol = {
    reflectSymbol: function () {
        return "CheckoutTrackingItem";
    }
};
var encodeRecordCons = /* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons();
var decodeRecordCons = /* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons();
var CheckoutTrackingItem = function (x) {
    return x;
};
var toFillFormTypeCheckoutTra = {
    fillFormDataType: function (v) {
        return Restaumatic_Form_TestHelpers.tyVar("unknown");
    }
};
var newtypeCheckoutTrackingIt = {
    Coercible0: function () {
        return undefined;
    }
};
var hasFieldCheckoutTrackingI = function (dictHasField) {
    return dictHasField;
};
var eqCheckoutTrackingItem = {
    eq: function (x) {
        return function (y) {
            return eq(x.list)(y.list) && eq1(x.trackingId)(y.trackingId);
        };
    }
};
var genericCheckoutTrackingItem = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var showCheckoutTrackingItem = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericCheckoutTrackingItem)(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons(listIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsConsNil(trackingIdIsSymbol)(Data_UUID.showUUID))(/* #__PURE__ */ Data_Maybe.showMaybe(Restaumatic_Analytics_Types_ItemList.showItemList)))))(CheckoutTrackingItemIsSymbol))
};
var unscrambleDecodeCheckoutTrackingItem = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Generic.genericUnsafeDecode(genericCheckoutTrackingItem)(/* #__PURE__ */ Unscramble_Generic.genericDecodeConstructor(/* #__PURE__ */ Unscramble_Generic.genericDecodeArgsArgument(/* #__PURE__ */ Unscramble.decodeRecord1()(/* #__PURE__ */ Unscramble.decodeRecordCons(listIsSymbol)(/* #__PURE__ */ Unscramble.decodeMaybe(Restaumatic_Analytics_Types_ItemList.unscrambleDecodeItemList))(/* #__PURE__ */ Unscramble.decodeRecordCons(trackingIdIsSymbol)(Data_UUID.udecodeUUID)(Unscramble.decodeRecordNil))))))(Unscramble_Generic.defaultOptions)
};
var encodeCheckoutTrackingItem = {
    encode: /* #__PURE__ */ Foreign_Encoding.defaultEncode(genericCheckoutTrackingItem)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor(CheckoutTrackingItemIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsRecord()(/* #__PURE__ */ encodeRecordCons(/* #__PURE__ */ encodeRecordCons(Foreign_Generic_Class.encodeRecordNil)(trackingIdIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Data_UUID.encodeUUID)))(listIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeEncode(Restaumatic_Analytics_Types_ItemList.encodeItemList)))))))
};
var decodeCheckoutTrackingItem = {
    decode: /* #__PURE__ */ Foreign_Encoding.defaultDecode(genericCheckoutTrackingItem)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor(CheckoutTrackingItemIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsRecord()(/* #__PURE__ */ decodeRecordCons(/* #__PURE__ */ decodeRecordCons(Foreign_Generic_Class.decodeRecordNil)(trackingIdIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Data_UUID.decodeUUID))())(listIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeDecode(Restaumatic_Analytics_Types_ItemList.decodeItemList)))())))(Foreign_Generic_Class.genericCountArgsArgument))
};
export {
    CheckoutTrackingItem,
    genericCheckoutTrackingItem,
    eqCheckoutTrackingItem,
    showCheckoutTrackingItem,
    encodeCheckoutTrackingItem,
    decodeCheckoutTrackingItem,
    unscrambleDecodeCheckoutTrackingItem,
    toFillFormTypeCheckoutTra,
    hasFieldCheckoutTrackingI,
    newtypeCheckoutTrackingIt
};
